module.exports = __webpack_public_path__ + "img/33792f4030c5160814d41e720bc3d072.jpg";